export const BASE_URL = document
  .getElementsByTagName('base')[0]
  .getAttribute('href')

export const FETCH_STATUS = {
  NOT_YET_FETCHED: 0,
  FETCHING: 1,
  LOADED: 2,
  FETCH_FAILED: 3,
}

export const EDIT_MODES = {
  NEW: 1,
  EDIT: 2,
}

export const CLUSTER_LAYER = {
  INCIDENTS: 'INCIDENT_LAYER',
  AI: 'AI_LAYER',
}

export const TWITTER_LAYER_ID = 23

export const MOBILE_SCREEN_WIDTH = 600

export const ICONS = {
  AI: {
    ACTIVE: { DIR: 'images/icons/ai/active/' },
    BORDERLESS: { DIR: 'images/icons/ai/borderless/' },
    POPUP: { DIR: 'images/icons/ai/popup/' },
    DIR: 'images/icons/ai/inactive/',
  },
  BORDERLESS: {
    BW: { DIR: 'images/icons/borderless/bw/' },
    DIR: 'images/icons/borderless/',
  },
  ACTIVE: { DIR: 'images/icons/active/' },
  SENT: { DIR: 'images/icons/sent/' },
  MUNICIPALITIES: {
    ACTIVE: { DIR: 'images/icons/municipalities/active/' },
    SENT: { DIR: 'images/icons/municipalities/sent/' },
    DIR: 'images/icons/municipalities/',
  },
  DIR: 'images/icons/',
}
